import React, { useEffect, useState } from "react";
import propTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import {
  Badge,
  Button,
  Card,
  CloseButton,
  Form,
  Placeholder,
} from "react-bootstrap";
import {
  CallSvgIcn,
  EmailSvgIcn,
  WebsiteSvgIcn,
  PathwaySvgIcn,
  SpathwaySvgIcn,
  KeywordsSvgIcn,
  LocationSvgIcn,
  GridSvgIcn,
  ListSvgIcn,
  NoDataSvgIcn,
  ClinksMemberSvgIcn,
  CheckSvgIcn,
  NoImgSvgIcn,
  ClearDataSvgIcn,
  CountySvgIcn,
} from "svgIcon/index";
import DynamicPagination from "components/FormsComponents/DynamicPagination";
import { FaChevronDown, FaChevronUp, FaStar } from "react-icons/fa";
import TooltipTextComponent from "components/FormsComponents/TooltipTextComponent";
import { getStorageData, htmlParser } from "utils/helper";
import { DOMAIN_MTC } from "constants/app";

import CarouselComponent from "components/FormsComponents/CarouselComponent";
import TextBoxComponent from "components/FormsComponents/TextBoxComponent";

const OrgDetailsComponent = (props) => {
  const {
    formData,
    setFormData,
    agencyData,
    totalRecord = 0,
    totalPages,
    currentPage,
    setCurrentPage,
    loader,
    domain_status,
    listStatus,
    setListStatus,
    limit,
    setLimit,
  } = props;

  const navigate = useNavigate();
  const domain = getStorageData("domain");
  const clearFieldData = () => {
    setFormData({
      ...formData,
      pathway: [],
      pathway_name: [],
      sub_pathway: [],
      sub_pathway_name: [],
      keyword: [],
      keyword_name: [],
      county: [],
      county_name: [],
      // county: "",
      name: "",
    });
  };

  const handleRemoveFilter = (name, value) => {
    var name_append = name + "_name";
    let newArray = formData?.[name].filter((item, i) => item !== value);
    let newArrayName = formData?.[name_append].filter(
      (item, i) => item.value !== value,
    );
    setFormData({
      ...formData,
      [name]: newArray,
      [name_append]: newArrayName,
    });
  };

  // const handleInput = ({ target: { name, value, selectData } }) => {
  //   let new_name = name + "_name";
  //   const cleanLabel =
  //     typeof selectData?.label === "string"
  //       ? selectData.label
  //       : selectData?.label?.props?.children?.[1] || "";

  //   setFormData({
  //     ...formData,
  //     [name]: value,
  //     [new_name]: {
  //       ...selectData,
  //       label: cleanLabel,
  //     },
  //   });
  // };

  const handleClinksMember = ({ target: { name, value, checked } }) => {
    setFormData({
      ...formData,
      [name]: checked,
    });
  };

  const showDescriptionLength = 275;
  // const showPathwayLength = 5;
  // const showSubPathwayLength = 5;
  const [showMoreString, setShowMoreString] = useState({
    description: { length: showDescriptionLength, id: "" },
    // pathway: { length: showPathwayLength, id: "" },
    // sub_pathway: { length: showSubPathwayLength, id: "" },
  });

  const showDescriptionOrg = (data, id, currentValue, fieldName) => {
    let fieldId = currentValue.id;
    return (
      <>
        {htmlParser(
          data
            .substring(
              0,
              fieldId === id ? currentValue.length : showDescriptionLength,
            )
            .split("\n")
            .join("<br />"),
        )}
        {fieldId !== id && data.length > showDescriptionLength ? (
          <span
            title="Read more"
            className="read__moreless d-inline-flex align-items-center text-primary fw-medium cursor-pointer ms-1"
            onClick={() =>
              moreLessStatus(fieldName, data, id, true, showDescriptionLength)
            }
          >
            <span>Read more</span>
            <FaChevronDown
              className="ms-1 opacity-75"
              style={{ width: "10", height: "10" }}
            />
          </span>
        ) : data.length > showDescriptionLength && fieldId === id ? (
          <span
            title="Read less"
            className="read__moreless d-inline-flex align-items-center text-primary fw-medium cursor-pointer ms-1"
            onClick={() =>
              moreLessStatus(fieldName, data, id, false, showDescriptionLength)
            }
          >
            <span>Read less</span>
            <FaChevronUp
              className="ms-1 opacity-75"
              style={{ width: "10", height: "10" }}
            />
          </span>
        ) : (
          ""
        )}
      </>
    );
  };

  // const showSearchInfoMore = (data, id, currentValue, fieldName) => {
  //   let fieldId = currentValue.id;
  //   let showLengthData =
  //     fieldName === "sub_pathway" ? showSubPathwayLength : showPathwayLength;
  //   let showLast =
  //     fieldId === id ? currentValue.length - 1 : showLengthData - 1;
  //   showLast = data.length <= showLast ? data.length - 1 : showLast;
  //   return (
  //     <>
  //       {data
  //         .slice(0, fieldId === id ? currentValue.length : showLengthData)
  //         .map((item, index) =>
  //           fieldName === "sub_pathway" ? (
  //             <span className="text-gray" key={index}>
  //               {item.label}
  //               {index < showLast ? (
  //                 <span className="text-gray opacity-25 ms-1">•</span>
  //               ) : (
  //                 " "
  //               )}
  //             </span>
  //           ) : (
  //             <span key={index}>
  //               {item.label}
  //               {index < showLast ? ", " : " "}
  //             </span>
  //           )
  //         )}

  //       {fieldId !== id && data.length > showLengthData ? (
  //         <span
  //           title="Read more"
  //           className="read__moreless d-inline-flex align-items-center text-primary fw-medium cursor-pointer"
  //           onClick={() =>
  //             moreLessStatus(fieldName, data, id, true, showLengthData)
  //           }
  //         >
  //           <span>Read more</span>
  //           <FaChevronDown
  //             className="ms-1 opacity-75"
  //             style={{ width: "10", height: "10" }}
  //           />
  //         </span>
  //       ) : data.length > showLengthData && fieldId === id ? (
  //         <span
  //           title="Read less"
  //           className="read__moreless d-inline-flex align-items-center text-primary fw-medium cursor-pointer"
  //           onClick={() =>
  //             moreLessStatus(fieldName, data, id, false, showLengthData)
  //           }
  //         >
  //           <span>Read less</span>
  //           <FaChevronUp
  //             className="ms-1 opacity-75"
  //             style={{ width: "10", height: "10" }}
  //           />
  //         </span>
  //       ) : (
  //         ""
  //       )}
  //     </>
  //   );
  // };

  const moreLessStatus = (field, data, id, type, staticLength) => {
    let set_data = type
      ? {
          length: data.length,
          id: id,
        }
      : {
          length: staticLength,
        };
    setShowMoreString({ ...showMoreString, [field]: set_data });
  };

  const onPageChange = (page) => {
    setCurrentPage(page);
  };

  const [showPathway, setShowPathway] = useState(5);
  const showSubPathway = showPathway - formData?.pathway_name?.length;
  const showKeyword = showSubPathway - formData?.sub_pathway_name?.length;
  const showCounty = showKeyword - formData?.keyword_name?.length;
  const countSelectedData =
    formData?.pathway_name?.length +
    formData?.sub_pathway_name?.length +
    formData?.keyword_name?.length +
    formData?.county_name?.length;
  const skeletonLoader = agencyData?.length ? agencyData : [1, 2, 3, 4, 5, 6];
  useEffect(() => {
    const updateGridViewStatus = () => {
      if (window.innerWidth <= 768) {
        setListStatus(false);
      } else {
        setListStatus(true);
      }
      if (window.innerWidth <= 991) {
        setLimit(10);
      } else {
        setLimit(limit);
      }
    };
    // Run once on mount
    updateGridViewStatus();
    // Run on resize
    window.addEventListener("resize", updateGridViewStatus);
    // Cleanup
    return () => {
      window.removeEventListener("resize", updateGridViewStatus);
    };
  }, []);
  return (
    <>
      <div className="card__rbox">
        {domain === DOMAIN_MTC && (
          <>
            {formData?.pathway_name?.length || formData?.county_name?.length ? (
              <div className="card__rtop">
                <div className="sfilters d-flex flex-wrap align-items-center">
                  {/* <h6>Pathway:</h6> */}
                  {formData?.pathway_name
                    .slice(0, showPathway)
                    .map((items, idx) => (
                      <Badge
                        key={idx}
                        pill
                        bg="white"
                        text="dark"
                        className="fs__items d-flex align-items-center"
                        title={items.label}
                      >
                        <PathwaySvgIcn
                          style={{ width: "14px", height: "15px" }}
                          className="me-1 org__pop"
                        />
                        <span>{items.label}</span>
                        <CloseButton
                          className="ms-2 p-0 org__pop"
                          onClick={() => {
                            handleRemoveFilter("pathway", items.value);
                          }}
                        />
                      </Badge>
                    ))}
                  {formData?.sub_pathway_name?.length && showSubPathway > 0
                    ? formData?.sub_pathway_name
                        .slice(0, showSubPathway)
                        .map((items, idx) => (
                          <Badge
                            key={idx}
                            pill
                            bg="white"
                            text="dark"
                            className="fs__items d-flex align-items-center"
                            title={items.label}
                          >
                            <SpathwaySvgIcn
                              style={{ width: "14px", height: "15px" }}
                              className="me-1 org__pop"
                            />
                            <span>{items.label}</span>
                            <CloseButton
                              className="ms-2 p-0 org__pop"
                              onClick={() => {
                                handleRemoveFilter("sub_pathway", items.value);
                              }}
                            />
                          </Badge>
                        ))
                    : ""}
                  {formData?.keyword_name?.length && showKeyword > 0
                    ? formData.keyword_name
                        .slice(0, showKeyword)
                        .map((items, idx) => (
                          <Badge
                            key={idx}
                            pill
                            bg="white"
                            text="dark"
                            className="fs__items d-flex align-items-center"
                            title={items.label}
                          >
                            <KeywordsSvgIcn
                              style={{ width: "14px", height: "15px" }}
                              className="me-1 org__pop"
                            />
                            <span>{items.label}</span>
                            <CloseButton
                              className="ms-2 p-0 org__pop"
                              onClick={() => {
                                handleRemoveFilter("keyword", items.value);
                              }}
                            />
                          </Badge>
                        ))
                    : ""}
                  {formData?.county_name?.length && showCounty > 0
                    ? formData.county_name
                        .slice(0, showCounty)
                        .map((items, idx) => (
                          <Badge
                            key={idx}
                            pill
                            bg="white"
                            text="dark"
                            className="fs__items d-flex align-items-center"
                            title={items.label}
                          >
                            <CountySvgIcn
                              style={{ width: "14px", height: "15px" }}
                              className="me-1 org__pop"
                            />
                            <span>{items.label}</span>
                            <CloseButton
                              className="ms-2 p-0 org__pop"
                              onClick={() => {
                                handleRemoveFilter("county", items.value);
                              }}
                            />
                          </Badge>
                        ))
                    : ""}
                  {countSelectedData > showPathway && (
                    <Badge
                      title="See all"
                      pill
                      bg="white"
                      text="dark"
                      className="fs__items fs__moreless d-flex align-items-center justify-content-center cursor-pointer"
                      onClick={() => setShowPathway(countSelectedData)}
                    >
                      <span className="fw-semibold">
                        +{countSelectedData - showPathway}
                      </span>
                    </Badge>
                  )}
                  {countSelectedData === showPathway &&
                    countSelectedData > 5 && (
                      <Badge
                        title="Less all"
                        pill
                        bg="white"
                        text="dark"
                        className="fs__items fs__moreless d-flex align-items-center justify-content-center cursor-pointer"
                        onClick={() => setShowPathway(5)}
                      >
                        <span className="fw-semibold">
                          -{countSelectedData - 5}
                        </span>
                      </Badge>
                    )}
                  {countSelectedData > 0 && (
                    <Button
                      title="Clear all"
                      variant="link"
                      className="fs__items org__pop ms-1 text-dark p-0 border-0 shadow-none text-decoration-underline"
                      onClick={() => {
                        clearFieldData();
                      }}
                    >
                      Clear all
                    </Button>
                  )}
                </div>
              </div>
            ) : (
              ""
            )}
          </>
        )}

        <div className="card__rbottom bg-white">
          {/* card__rfilter */}
          <div
            className={`card__rfilter d-flex align-items-center ${
              domain_status ? "justify-content-between" : "justify-content-end"
            }`}
          >
            {domain_status ? (
              <div className="card__right d-flex align-items-center gap-2">
                <Form.Check
                  label={
                    formData?.is_clinks
                      ? "Clinks Members"
                      : "Click to show only Clinks members"
                  }
                  type="switch"
                  id="custom-switch"
                  checked={formData?.is_clinks ? true : false}
                  name={"is_clinks"}
                  onChange={handleClinksMember}
                  className="mb-0 pb-0"
                />
              </div>
            ) : (
              ""
            )}
            <div className="card__left d-flex align-items-center gap-2">
              {/* <div className="gl__select d-flex align-items-center gap-2">
                <SelectComponent
                  style={{ width: "140px" }}
                  className="single__select"
                  option={startOption}
                  name={"star"}
                  value={formData && formData.star_name}
                  placeholder={"Select Star"}
                  handleInput={handleInput}
                  isSearchable={false}
                />
              </div> */}
              <div className="gl__grp d-none d-md-flex align-items-center">
                <span
                  title="List View"
                  className={`gl__items org__pop d-flex align-items-center justify-content-center position-relative cursor-pointer${
                    listStatus ? " active" : ""
                  }`}
                  onClick={() => {
                    setListStatus(true);
                  }}
                >
                  <ListSvgIcn />
                </span>
                <span className="gl__iline"></span>
                <span
                  title="Grid View"
                  className={`gl__items org__pop d-flex align-items-center justify-content-center position-relative cursor-pointer${
                    !listStatus ? " active" : ""
                  }`}
                  onClick={() => {
                    setListStatus(false);
                  }}
                >
                  <GridSvgIcn />
                </span>
              </div>
            </div>
          </div>
          {!formData?.pathway?.length &&
          !formData?.name &&
          !formData?.county ? (
            <div className="w-100 text-center py-4 px-2">
              <ClearDataSvgIcn />
            </div>
          ) : agencyData?.length || loader ? (
            <div
              className={`card__rolist ${
                listStatus ? "org__list" : "org__grid"
              }`}
            >
              {loader
                ? skeletonLoader.map((_, idx) => (
                    <div className="rolist__items">
                      {/* Image Placeholder */}
                      <div className="rolist__igallary w-100">
                        <div className="rolist__iimg">
                          <Placeholder as="div" animation="glow">
                            <Placeholder
                              xs={12}
                              style={{ height: "150px", width: "100%" }}
                              className="rounded"
                            />
                          </Placeholder>
                        </div>
                        {/* Content Placeholder */}
                        <div className="rolist__icontent d-flex flex-column">
                          {/* Top Section */}
                          <div className="icontent__top d-flex justify-content-between align-items-start position-relative">
                            <Placeholder
                              as="div"
                              animation="glow"
                              className="w-50"
                            >
                              <Placeholder xs={8} />
                            </Placeholder>
                            <Placeholder
                              as="div"
                              animation="glow"
                              className="w-25 text-end"
                            >
                              <Placeholder xs={5} />
                            </Placeholder>
                          </div>

                          {/* Title Placeholder */}
                          <Placeholder
                            as="div"
                            animation="glow"
                            className="w-75 my-1"
                          >
                            <Placeholder xs={10} />
                          </Placeholder>

                          {/* Subpathway Placeholder */}
                          <Placeholder
                            as="div"
                            animation="glow"
                            className="w-100 my-1"
                          >
                            <Placeholder xs={12} />
                          </Placeholder>

                          {/* Address Placeholder */}
                          <Placeholder
                            as="div"
                            animation="glow"
                            className="w-50 my-1"
                          >
                            <Placeholder xs={6} />
                          </Placeholder>

                          {/* Description Placeholder */}
                          <Placeholder
                            as="div"
                            animation="glow"
                            className="w-100 my-1"
                          >
                            <Placeholder xs={12} />
                          </Placeholder>
                        </div>
                      </div>

                      {/* Action Section Placeholder */}
                      <div className="rolist__iaction d-flex flex-column align-items-center justify-content-center">
                        {/* Star Review Placeholder */}
                        <Placeholder
                          as="div"
                          animation="glow"
                          className="w-50 mb-2 text-center"
                        >
                          <Placeholder xs={6} />
                        </Placeholder>

                        {/* Contact Buttons Placeholder */}
                        <div className="iaction__contact d-flex align-items-center justify-content-center gap-2">
                          {[...Array(3)].map((_, idx) => (
                            <Placeholder.Button
                              key={idx}
                              variant="secondary"
                              xs={4}
                              className="rounded-circle placeholder opacity-50"
                            />
                          ))}
                        </div>
                      </div>
                    </div>
                  ))
                : agencyData.map((items, index) => (
                    <div className="rolist__items">
                      <div className="rolist__igallary">
                        {/* This span use on click in image and content */}
                        <span
                          className="click__here cursor-pointer"
                          onClick={() => {
                            navigate(`/clinks-details/${items.agency_id}`);
                          }}
                          title="Click to View"
                        ></span>
                        <div className="rolist__iimg">
                          {items.image_data && items.image_data.length ? (
                            <CarouselComponent data={items} />
                          ) : items.company_logo && items.company_logo_url ? (
                            <Card.Img
                              variant="top"
                              src={items.company_logo_url}
                              className="single__img w-100 h-100 object-fit-contain"
                            />
                          ) : (
                            <div className="no__img p-3 bg-light text-center d-flex flex-column align-items-center justify-content-center gap-3">
                              <NoImgSvgIcn />
                              <span className="text-dark opacity-50 fw-medium">
                                The image associated with this organisation is
                                not visible.
                              </span>
                            </div>
                          )}
                        </div>
                        <div className="rolist__icontent d-flex flex-column">
                          <>
                            <div className="icontent__top d-flex justify-content-between align-items-start position-relative">
                              {/* <div className="icontent__tpathway">
                                {items?.pathway_data?.length ? (
                                  <div className="tpathway__items">
                                    {showSearchInfoMore(
                                      items.pathway_data,
                                      items.id,
                                      showMoreString.pathway,
                                      "pathway"
                                    )}
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div> */}
                              {items.name && (
                                <div className="icontent__ttitle text-dark fw-bold">
                                  {items.name}
                                </div>
                              )}
                              {items.clinks_members &&
                              items.clinks_directory ? (
                                <div className="icontent__tbrand d-flex align-items-center gap-1">
                                  <ClinksMemberSvgIcn />
                                  <p className="mb-0 text-brand-primary">
                                    <small>
                                      <small className="fw-500">Member</small>
                                    </small>
                                  </p>
                                  {/* <CheckSvgIcn /> */}
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                            {/* {items?.pathway_subcategory_data?.length ? (
                              <div className="icontent__tsubpathway">
                                <div className="tspathway__items">
                                  {showSearchInfoMore(
                                    items.pathway_subcategory_data,
                                    items.id,
                                    showMoreString.sub_pathway,
                                    "sub_pathway"
                                  )}
                                </div>
                              </div>
                            ) : (
                              ""
                            )} */}
                            {items.office_address && (
                              <TooltipTextComponent
                                children={
                                  items.office_address && (
                                    <div className="icontent__taddress d-flex align-items-center bg-white">
                                      <LocationSvgIcn />{" "}
                                      <span className="ellipsisL1 text-gray ms-2">
                                        {items.office_address}
                                      </span>
                                    </div>
                                  )
                                }
                                tooltip_children={items.office_address}
                              />
                            )}
                            {items.description && (
                              <div className="icontent__tdescription text-gray">
                                {showDescriptionOrg(
                                  items.description,
                                  items.id,
                                  showMoreString.description,
                                  "description",
                                )}
                              </div>
                            )}
                          </>
                        </div>
                      </div>
                      <div className="rolist__iaction d-flex flex-column align-items-center justify-content-center">
                        {/* <div className="iaction__review d-flex align-items-center gap-1 rounded-pill">
                          <span className="fw-bold text-dark"> 4.5
                          </span>
                          <FaStar
                            className={items?.feedback > 0 ? "text-yellow" : ""}
                          />
                          <span className="text-gray fw-normal small">
                            ({"5"} Reviews)
                          </span>
                        </div> */}
                        {items.website_link ||
                        items.email ||
                        items.contact_number ? (
                          <div className="iaction__contact d-flex align-items-center justify-content-center gap-2">
                            {items.contact_number && (
                              <TooltipTextComponent
                                children={
                                  <span className="contact__items d-flex align-items-center justify-content-center cursor-pointer rounded-pill">
                                    <CallSvgIcn />
                                  </span>
                                }
                                tooltip_children={items.contact_number}
                                onClick={() =>
                                  (window.location.href = `tel:${items.contact_number}`)
                                }
                              />
                            )}
                            {items.email && (
                              <TooltipTextComponent
                                children={
                                  <span className="contact__items d-flex align-items-center justify-content-center cursor-pointer rounded-pill">
                                    <EmailSvgIcn />
                                  </span>
                                }
                                tooltip_children={items.email}
                                onClick={() =>
                                  (window.location.href = `mailto:${items.email}`)
                                }
                              />
                            )}
                            {items.website_link && (
                              <TooltipTextComponent
                                children={
                                  <span className="contact__items d-flex align-items-center justify-content-center cursor-pointer rounded-pill">
                                    <WebsiteSvgIcn />
                                  </span>
                                }
                                tooltip_children={
                                  items.website_link ? items.website_link : ""
                                }
                                onClick={() =>
                                  window.open(items.website_link, "_blank")
                                }
                              />
                            )}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  ))}
            </div>
          ) : (
            <div className="card__rolist no__data">
              <div className="w-100 text-center py-4 px-2">
                <NoDataSvgIcn />
              </div>
            </div>
          )}
        </div>
        <div className="card__rpagination d-flex flex-md-row flex-column justify-content-between align-items-center gap-2">
          <div className="card__rpleft small">
            Showing {totalRecord} results
          </div>
          <div className="card__rpmiddle">
            <DynamicPagination
              totalPages={totalPages}
              currentPage={currentPage}
              onPageChange={onPageChange}
            />
          </div>
          <div className="card__rpright">
            <Form.Select
              name="limit"
              value={limit}
              onChange={(e) => {
                setLimit(e.target.value);
                setCurrentPage(1);
              }}
            >
              <option value="5">5 / page</option>
              <option value="10">10 / page</option>
              <option value="25">25 / page</option>
              <option value="50">50 / page</option>
              <option value="100">100 / page</option>
            </Form.Select>
          </div>
        </div>
      </div>
    </>
  );
};
OrgDetailsComponent.propTypes = {
  history: propTypes.object,
};
export default OrgDetailsComponent;
